import { render, staticRenderFns } from "./SubmitContact.vue?vue&type=template&id=66bc0df2"
import script from "./SubmitContact.vue?vue&type=script&lang=js"
export * from "./SubmitContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports